"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var browser_info_1 = require("../credit_cards/browser_info");
var wrapped_location_1 = require("../lib/wrapped_location");
function buildCreditCardEntry(creditCardEntry) {
    var useExistingCreditCard = creditCardEntry.useExistingCreditCard, editingCard = creditCardEntry.editingCard, selectedCreditCardId = creditCardEntry.selectedCreditCardId, billingCardAddress = creditCardEntry.billingCardAddress, tokenizedCreditCardData = creditCardEntry.tokenizedCreditCardData, cardData = creditCardEntry.cardData;
    if (useExistingCreditCard) {
        return {
            creditCardId: selectedCreditCardId,
        };
    }
    var creditCardId = editingCard ? selectedCreditCardId : '';
    return {
        creditCardId: creditCardId,
        address: {
            countryCode: billingCardAddress.countryCode,
            postalCode: billingCardAddress.postalCode,
        },
        adyenCreditCard: {
            cardholderName: cardData.cardholderName,
            tokenizedFields: JSON.stringify(tokenizedCreditCardData),
        },
    };
}
exports.buildCreditCardEntry = buildCreditCardEntry;
function buildUpdateBillingMethodMutationInput(billingMethodMutationInput) {
    var cardData = billingMethodMutationInput.cardData, tokenizedCreditCardData = billingMethodMutationInput.tokenizedCreditCardData, billingCardAddress = billingMethodMutationInput.billingCardAddress, editingCard = billingMethodMutationInput.editingCard, selectedCreditCardId = billingMethodMutationInput.selectedCreditCardId, useExistingCreditCard = billingMethodMutationInput.useExistingCreditCard, returnUrl = billingMethodMutationInput.returnUrl;
    return {
        returnUrl: returnUrl,
        origin: wrapped_location_1.default.origin,
        browserInfo: JSON.stringify(browser_info_1.browserInfo()),
        creditCard: buildCreditCardEntry({
            cardData: cardData,
            tokenizedCreditCardData: tokenizedCreditCardData,
            billingCardAddress: billingCardAddress,
            editingCard: editingCard,
            selectedCreditCardId: selectedCreditCardId,
            useExistingCreditCard: useExistingCreditCard,
        }),
    };
}
exports.buildUpdateBillingMethodMutationInput = buildUpdateBillingMethodMutationInput;
//# sourceMappingURL=billing_method_operation_inputs.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/billing/billing_method_operation_inputs.js
// module id = uCJT
// module chunks = 20 21